import { Garland, Logos } from './Treatments/ChicagoTreatment';
import PpaPattern, { PpaLogo } from './Treatments/PpaTreatment';

export type Treatments = 'chicago' | 'ppa' | 'default';

const SpecialTreatment = ({
  isMobile,
  isXl,
  isMd,
  treatment
}: {
  isMobile: boolean;
  isXl: boolean;
  isMd: boolean;
  treatment: Treatments;
}) => {
  if (treatment === 'ppa') {
    if (isMobile) {
      return null;
    }

    return (
      <>
        <PpaPattern isXl={isXl} />
        <PpaLogo isXl={isXl} isMd={isMd} />
      </>
    );
  }

  if (treatment === 'chicago') {
    if (isMobile) {
      return null;
    }

    return (
      <>
        <Garland isMd={isMd} isXl={isXl} />
        <Logos isXl={isXl} />
      </>
    );
  }

  return null;
};

export default SpecialTreatment;
